<template>
  <div>
    <div class="m-b-10 f-s-10 m-t-10">
      <b class="text-inverse ts-uppercase">{{ $t('homePage.class') }}</b>
    </div>
    <ts-loading-banner :loading="loading">
      <div class="overflow-auto" style="min-height: 5rem; max-height: 10rem">
        <div
          class="widget-list widget-list-rounded m-b-10"
          v-if="classLists.length > 0"
        >
          <a
            href="#"
            class="widget-list-item ts-whitespace-no-wrap"
            v-for="(classes, index) in classLists"
            :key="index"
            @click.prevent="homework(classes)"
          >
            <div class="widget-list-media icon">
              <i
                class="fas fa-school text-white"
                :class="(bgName = randomBackground())"
              ></i>
            </div>
            <div class="widget-list-content">
              <h4 class="widget-list-title">{{ classes.class_name }}</h4>
            </div>
            <div class="widget-list-action text-right">
              <span class="badge badge-primary m-r-2" :class="bgName">{{
                getTotalByClass({ class_id: classes.class_id })
              }}</span>
              <i class="fa fa-angle-right fa-lg text-muted"></i>
            </div>
          </a>
        </div>
        <div class="widget-list widget-list-rounded m-b-10 inverse-mode" v-else>
          <a class="widget-list-item ts-whitespace-no-wrap">
            <div class="widget-list-content text-center">
              <h4 class="widget-list-title">{{ $t('homePage.noClass') }}</h4>
            </div>
          </a>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'class',
  data() {
    return {
      homeworkPending: 0,
      loading: false,
      backgrounds: [
        'bg-indigo',
        'bg-blue',
        'bg-purple',
        'bg-pink',
        'bg-red',
        'bg-orange',
        'bg-green',
        'bg-teal',
        'bg-primary',
        'bg-success',
        'bg-info',
        'bg-warning',
        'bg-danger'
      ]
    }
  },
  computed: {
    ...mapState('home/teacherHomework', ['resources', 'classLists']),
    ...mapGetters('home/teacherHomework', ['getTotalByClass'])
  },
  methods: {
    fetchClass() {
      this.loading = true
      this.$store
        .dispatch('home/teacherHomework/fetchClasses')
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    randomBackground() {
      return this.backgrounds[
        Math.floor(Math.random() * this.backgrounds.length)
      ]
    },
    homework(record) {
      this.$store.commit(
        'home/teacherHomeworkLinkFromHome/SET_CLASS_ID',
        record.class_id
      )
      this.$router.push({
        name: 'teacher-homework'
      })
    }
  },
  watch: {
    resources: function(value) {
      if (value) {
        this.fetchClass()
      }
    }
  }
}
</script>
